import { useState, useRef, useEffect } from 'react';
import { Filter, ChevronDown, Check, X } from 'lucide-react';

const CategoryFilter = ({ categories, selectedCategory, setSelectedCategory, allLabel = 'جميع التصنيفات', testIdPrefix = 'category' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const activeLabel = selectedCategory || allLabel;
  const hasFilter = !!selectedCategory;

  return (
    <div ref={ref} className="relative inline-block min-w-[200px]">
      <button
        onClick={() => setOpen(!open)}
        data-testid={`${testIdPrefix}-filter-trigger`}
        className={`
          w-full flex items-center justify-between gap-3 
          px-5 py-3 rounded-xl text-sm font-medium
          border-2 transition-all duration-200
          ${hasFilter
            ? 'bg-primary/10 border-primary/40 text-primary shadow-md'
            : 'bg-white border-gray-200 text-gray-700 hover:border-primary/30 hover:shadow-sm'}
        `}
      >
        <div className="flex items-center gap-2">
          <Filter className="w-4 h-4 shrink-0" />
          <span className="truncate">{activeLabel}</span>
        </div>
        <div className="flex items-center gap-1">
          {hasFilter && (
            <span
              role="button"
              data-testid={`clear-${testIdPrefix}-btn`}
              onClick={(e) => { e.stopPropagation(); setSelectedCategory(null); setOpen(false); }}
              className="p-0.5 rounded-full hover:bg-primary/20 transition-colors"
            >
              <X className="w-3.5 h-3.5" />
            </span>
          )}
          <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
        </div>
      </button>

      {open && (
        <div
          className="absolute z-50 mt-2 w-full bg-white rounded-xl border border-gray-200 shadow-xl overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200"
          data-testid={`${testIdPrefix}-filter-dropdown`}
        >
          <div className="max-h-[280px] overflow-y-auto py-1">
            <button
              onClick={() => { setSelectedCategory(null); setOpen(false); }}
              data-testid={`${testIdPrefix}-option-all`}
              className={`w-full flex items-center justify-between px-4 py-3 text-sm transition-colors ${!selectedCategory ? 'bg-primary/5 text-primary font-semibold' : 'text-gray-700 hover:bg-gray-50'}`}
            >
              <span>{allLabel}</span>
              {!selectedCategory && <Check className="w-4 h-4 text-primary" />}
            </button>
            <div className="mx-3 border-t border-gray-100" />
            {categories.filter(Boolean).map((cat) => (
              <button
                key={cat}
                onClick={() => { setSelectedCategory(cat); setOpen(false); }}
                data-testid={`${testIdPrefix}-option-${cat}`}
                className={`w-full flex items-center justify-between px-4 py-3 text-sm transition-colors ${selectedCategory === cat ? 'bg-primary/5 text-primary font-semibold' : 'text-gray-700 hover:bg-gray-50'}`}
              >
                <div className="flex items-center gap-2">
                  <span className={`w-2 h-2 rounded-full ${selectedCategory === cat ? 'bg-primary' : 'bg-gray-300'}`} />
                  <span>{cat}</span>
                </div>
                {selectedCategory === cat && <Check className="w-4 h-4 text-primary" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryFilter;
